<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            Request.do(this, this.data._id ? 'PUT' : 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.parts.groups.group}${this.data._id ? this.data._id : ''}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    $('#spinner').modal('toggle');
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        selectItem: function(item){
            this.data = JSON.parse(JSON.stringify(item));
            this.data.name = Common.camelize(this.data.name);
        },
        clearForm: function(){
            this.data = {};
            this.data.status = "ACTIVE";
        }
    }
}
</script>
